"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.ThemeContext = void 0;
var react_1 = __importDefault(require("react"));
var GlobalCss_1 = require("../global/GlobalCss");
var createTheme_1 = require("./createTheme");
var themes_1 = require("./themes");
exports.ThemeContext = react_1.default.createContext(themes_1.lightTheme);
function ThemeProvider(props) {
    var theme = props.theme, children = props.children;
    return (react_1.default.createElement(exports.ThemeContext.Provider, { value: theme },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(GlobalCss_1.DefaultGlobalCss, null),
            children)));
}
exports.ThemeProvider = ThemeProvider;
ThemeProvider.defaultProps = {
    theme: createTheme_1.createTheme(),
};
//# sourceMappingURL=ThemeContext.js.map